import { client } from '../client';
import { UserProfile, UserRoleName } from './types/UserProfile';

/**
 * Roles whose own row lives on a scoped `<prefix>/me` route instead of the shared `/me`.
 * The scoped payloads carry the role's full profile (client tags, client divisions and D1
 * network membership), which the shared `/me` leaves off, so a provider or care advisor
 * fetched through `/me` sees those fields blank on their own profile page.
 */
const SCOPED_ME_ROUTES: Record<string, string> = {
  [UserRoleName.CareAdvisor]: '/care_advisor/me',
  [UserRoleName.Collector]: '/collector/me',
  [UserRoleName.Provider]: '/provider/me',
};

/**
 * Signed-in user profile. Collectors must use **GET /collector/me** (not GET /collector/users/{id})
 * for their own row. Pass the role, or rely on `/me` plus the role detection below.
 */
export const getCurrentProfile = async (userRole?: string): Promise<UserProfile> => {
  const scopedRoute = userRole ? SCOPED_ME_ROUTES[userRole] : undefined;
  if (scopedRoute) {
    const { data } = await client.get(scopedRoute);
    return data;
  }

  const { data } = await client.get('/me');

  const detectedRoute = data.role?.name ? SCOPED_ME_ROUTES[data.role.name] : undefined;
  if (detectedRoute) {
    const { data: scopedData } = await client.get(detectedRoute);
    return scopedData;
  }

  return data;
};
